module.exports = __webpack_public_path__ + "static/img/bg_green.de66308e.png";